import { apiRequest } from "../util/apiUtils";

export const testimonialsList = async (params) => {
  try {
    const res = await apiRequest("get", `testimonial/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const testimonialsListFront = async (params) => {
  try {
    const res = await apiRequest("get", `/testimonial/list-front`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const testimonialsAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `testimonial/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const testimonialsDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `testimonial/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const testimonialsStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `testimonial/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const testimonialsOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `testimonial/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const testimonialsDetails = async (Id) => {
  try {
    // const res = await apiRequest("get", `post/detail`, {
    //   queries: params,
    // });
    const res = await apiRequest("get", `testimonial/detail/${Id}`, {});

    return res?.data;
  } catch (err) {
    throw err;
  }
};
